import { render, staticRenderFns } from "./ModalLateral.vue?vue&type=template&id=08252e38"
import script from "./ModalLateral.vue?vue&type=script&lang=js"
export * from "./ModalLateral.vue?vue&type=script&lang=js"
import style0 from "./ModalLateral.vue?vue&type=style&index=0&id=08252e38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports